import Vue from 'vue'
import store from '~/store'
import VueI18n from 'vue-i18n'
import axios from 'axios'

Vue.use(VueI18n)

const i18n = new VueI18n({
  locale: 'en',
  messages: {}
})

/**
* @param {String} locale
*/
export async function loadMessages (locale) {
  if (Object.keys(i18n.getLocaleMessage(locale)).length === 0) {
    await reloadMessages(locale)
  }

  if (i18n.locale !== locale) {
    i18n.locale = locale
  }
}

export async function reloadMessages (locale) {
  // Load static messages.

  const messagesBase = await import(/* webpackChunkName: "lang-[request]" */ `~/lang/${locale}/${locale}`)

  const messagesEvaluations = {

    'evaluations': {
      'entries': {
        'kid': {
          'titles': await import(`~/lang/${locale}/entries_titles_kid`)
        },
        'young': {
          'titles': await import(`~/lang/${locale}/entries_titles_young`)
        },
        'adult': {
          'titles': await import(`~/lang/${locale}/entries_titles_adult`)
        }
      },
      'tabs': await import(`~/lang/${locale}/tabs`),
      'errors': await import(`~/lang/${locale}/errors`),
      'head': {
        'step': await import(`~/lang/${locale}/header/step`),
        'category': await import(`~/lang/${locale}/header/category`),
        'criteria': await import(`~/lang/${locale}/header/criteria`),
        'button': await import(`~/lang/${locale}/header/button`)
      }
    }
  }

  // Load static messages from database.

  const messagesLanguages = {
    'languages': await import(`~/lang/${locale}/languages`)
  }

  const messagesGenders = {
    'genders': await import(`~/lang/${locale}/genders`)
  }

  const messagesScholarlevels = {
    'scholarlevels': await import(`~/lang/${locale}/scholarlevels`)
  }

  const messagesProfessionallevels = {
    'professionallevels': await import(`~/lang/${locale}/professionallevels`)
  }

  const messagesSatisfactionperceptions = {
    'satisfactionperceptions': await import(`~/lang/${locale}/satisfactionperceptions`)
  }

  const messagesNationalities = {
    'nationalities': await import(`~/lang/${locale}/nationalities`)
  }

  const messagesPages = {
    'pages': {
      'welcome': await import(`~/lang/${locale}/pages/welcome`)
    }
  }

  // Merge and store messages.

  const messages = Object.assign(
    {},
    messagesBase,
    messagesLanguages,
    messagesGenders,
    messagesScholarlevels,
    messagesProfessionallevels,
    messagesSatisfactionperceptions,
    messagesNationalities,
    messagesEvaluations,
    messagesPages
  )

  i18n.setLocaleMessage(locale, messages)
}

export function translateAndSort (messages, baseIdentifier) {
  var translatedAndSorted = []

  // Translate
  for (var i = 0; i < messages.length; i++) {
    translatedAndSorted[i] = { 'id': messages[i].id, 'name': i18n.t(baseIdentifier + '.' + messages[i].id) }
  }

  // Sort
  translatedAndSorted.sort(function (a, b) {
    var textA = a.name.toUpperCase()
    var textB = b.name.toUpperCase()
    return (textA < textB) ? -1 : (textA > textB) ? 1 : 0
  })

  return translatedAndSorted
}

(async function () {
  await loadMessages(store.getters['lang/locale'])
})()

export default i18n



// WEBPACK FOOTER //
// ./resources/js/plugins/i18n.js